module.exports = __webpack_public_path__ + "a7b1fde617d5fc405889cedbbc80227f.MP3";